import * as React from "react";
import { Product_product } from '@api/graphql/types';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';

interface PropType {
    product: Product_product;
}

type Props = PropType & InjectedIntlProps;

class ProductInfo extends React.Component<Props> {
    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.product.${id}` });
    }

    private format = (field: keyof Product_product, value: any) => {
        switch (field) {
            case 'price':
                return `${value} Ft`;
            case 'special_price':
                return `${value} Ft`;
            case 'vat':
                return `${value}%`;
            default:
                return value;
        }
    }

    public render() {
        const fields: Array<keyof Product_product> = ['id', 'ext_id', 'url_key', 'smarturl', 'price', 'price_unit', 'price_per_unit', 'vat', 'special_price', 'special_from_date', 'special_to_date', 'news_to_date', 'barcodes', 'alternative_quantity_name', 'default_quantity_name', 'default_quantity_minimum', 'default_quantity_scale', 'gift_message_available', 'updated_at'];

        return (
            <>
                {fields.map((field: keyof Product_product) => {
                    return (
                        <div key={field} className="row">
                            <div className={`col-sm-3`}>
                                <strong>{this.label(`info.${field}`)}</strong>
                            </div>
                            <div className={`col-sm-6`}>
                                {this.format(field, this.props.product[`${field}`])}
                            </div>
                        </div>
                    );
                })}
            </>
        );
    }
}

export default compose(
    injectIntl,
)(ProductInfo);


// WEBPACK FOOTER //
// ./src/modules/Product/components/ProductInfo.tsx